import {DatePipe} from '@angular/common';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {AppointTest, AssigmentTestUser} from '@core/models/tests';

export function upperFirst(value: string): string {
    return value.slice(0, 1).toUpperCase() + value.slice(1);
}

export function isNil(value: any): value is null | undefined {
    return value === null || typeof value === 'undefined';
}

export function isString(value: any): value is string {
    return typeof value === 'string';
}

export function isLettersOnly(value: string): value is string {
    return !!value.match(/^[A-Za-z]+$/);
}

export function isNumbersOnly(value: string): value is string {
    return !!value.match(/^[0-9]+$/);
}

export function isObject(value: any): boolean {
    return value !== null && typeof value === 'object';
}

export function getProperty(value: { [key: string]: any }, key: string): any {
    if (isNil(value) || !isObject(value)) {
        return undefined;
    }

    const keys: string[] = key.split('.');
    // tslint:disable-next-line:no-non-null-assertion
    let result: any = value[keys.shift()!];

    for (const k of keys) {
        if (isNil(result) || !isObject(result)) {
            return undefined;
        }

        result = result[k];
    }

    return result;
}

export function getDateTimeFromMs(date: number): string {
    return date ? new DatePipe('ru').transform(date * 1000, 'MM/dd/yyyy hh:mmaaa') : '';
}

export function compare(field?, order?) {
    const len = arguments.length;
    if (len === 0) {
        return (a, b) => (a < b && -1) || (a > b && 1) || 0;
    }
    if (len === 2) {
        switch (typeof field) {
            case 'number':
                return field < 0
                    ? (a, b) => (a < b && 1) || (a > b && -1) || 0
                    : (a, b) => (a < b && -1) || (a > b && 1) || 0;
            case 'string':
                return (a, b) => {
                    if (typeof a[field] === 'string') {
                        return ((a[field]?.toLowerCase() || '') > (b[field]?.toLowerCase() || '')) ? 1 :
                            (((b[field]?.toLowerCase() || '') > (a[field]?.toLowerCase() || '')) ? -1 : 0);
                    } else if (typeof a[field] === 'boolean') {
                        return ((b[field])) ? 1 : (((a[field])) ? -1 : 0);
                    }
                };
        }
    }
}

export function checkHeader(item) {
    console.log(item);
    if (typeof item === 'string') {
        return {title: item, header: true};
    } else {
        return item;
    }
}

export function decodeFunc(str: string): string {
    const elem1 = document.createElement('textarea');
    if (str && typeof (str) === 'string') {
        if (!str || str === '') {
            return '';
        }
        elem1.innerHTML = str;
        return elem1.value;
    }
    return str;
}

export function throwErr(err: Error, load?: Subject<any> | BehaviorSubject<any>): Observable<any> {
    load.next(false);
    throw err;
}

export function score(test: AppointTest, user: AssigmentTestUser) {
    const criteria = {
        text: null,
        class: null,
    };
    if (!user.correct_count && +new Date(test.finished_at) < +new Date(test.now) && !user.finished_at) {
        criteria.text = 'Неявка';
        criteria.class = 'red';
        return criteria;
    } else if (!user.correct_count && !user.finished_at) {
        criteria.text = '-';
        return criteria;
    }

    if (user.finished_at) {
        if (test.criteria_fine && !test.criteria_good && !test.criteria_satisfactory) {
            if (user.correct_count >= test.criteria_fine) {
                criteria.text = 'Сдан';
                criteria.class = 'green';
            } else {
                criteria.text = 'Не cдан';
                criteria.class = 'red';
            }
        } else {
            if (user.correct_count < test.criteria_satisfactory) {
                criteria.text = 'Не сдан';
                criteria.class = 'red';
            }
            if (user.correct_count >= test.criteria_satisfactory && user.correct_count < test.criteria_good) {
                criteria.text = 'Удовлетворительно';
                criteria.class = 'orange';
            }
            if (user.correct_count < test.criteria_fine && user.correct_count >= test.criteria_good) {
                criteria.text = 'Хорошо';
                criteria.class = 'yellow';
            }
            if (user.correct_count >= test.criteria_fine) {
                criteria.text = 'Отлично';
                criteria.class = 'green';
            }
        }

        return criteria;
    } else {
        criteria.text = '-';

        return criteria;
    }

}
